import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import styles from './index.module.scss'
import DisplayText from '../../components/DisplayText';
import { featuredPost, postCards } from './articles'

const ArrowIcon = () => (
  <svg viewBox="0 0 18 18" aria-hidden="true">
    <path
      d="M4 9h10M10 5l4 4-4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const AvatarStack = ({ authors }) => (
  <div className={styles.avatarStack} aria-label={authors.map((author) => author.name).join(', ')}>
    {authors.map((author, index) => (
      <img
        key={author.name}
        className={styles.avatar}
        src={author.avatar}
        alt={author.name}
        title={author.name}
        style={{ zIndex: authors.length - index }}
      />
    ))}
  </div>
)

const scrollToPageTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
}

const ReadMoreLink = ({ to, external }) => {
  if (external) {
    return (
      <a className={styles.readMore} href={to} rel="noreferrer" onClick={scrollToPageTop}>
        <ArrowIcon />
        <span>Read More</span>
      </a>
    )
  }

  return (
    <Link className={styles.readMore} to={to} onClick={scrollToPageTop}>
      <ArrowIcon />
      <span>Read More</span>
    </Link>
  )
}

const Blog = () => {
  useEffect(() => {
    scrollToPageTop()
  }, [])

  return (
    <main className={styles.page}>
      <div className={`${styles.headWrap} ${styles.reveal} ${styles.reveal1}`}>
        <DisplayText fullText="We publish before we build"/>
        <p className={styles.headSubTitle}>Every system we build starts as a thesis - and becomes enforceable before capital moves.</p>
      </div>
      <div className={styles.container}>
        <section className={`${styles.featuredSection} ${styles.reveal} ${styles.reveal2}`}>
          <div className={styles.featuredMediaWrap}>
            <img className={styles.featuredMedia} src={featuredPost.image} alt={featuredPost.title} />
          </div>

          <div className={styles.featuredContent}>
            <div className={styles.tag}>{featuredPost.tag}</div>
            <h1 className={styles.featuredTitle}>{featuredPost.title}</h1>
            <AvatarStack authors={featuredPost.authors} />
            <p className={styles.summary}>{featuredPost.summary}</p>
            <ReadMoreLink to={featuredPost.to} external={featuredPost.external} />
          </div>
        </section>

        <section className={styles.gridSection}>
          {postCards.map((post) => (
            <article key={post.title} className={`${styles.card} ${styles.reveal} ${styles.cardReveal}`}>
              <div className={styles.cardMediaWrap}>
                <img className={styles.cardMedia} src={post.image} alt={post.title} />
              </div>

              <div className={styles.cardContent}>
                <div className={styles.tag}>{post.tag}</div>
                <h2 className={styles.cardTitle}>{post.title}</h2>
                <AvatarStack authors={post.authors} />
                <p className={styles.summary}>{post.summary}</p>
                <ReadMoreLink to={post.to} external={post.external} />
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  )
}

export default Blog